<!-- @if(!isMobileDevice){ -->
<!-- <div class="dashboard-wrapper d-flex flex-column">
    <div class="d-flex flex-column"> -->
<div class="the_container">
  <div class="d-flex justify-content-between">
    @if(!isMobileDevice){
    <span class="details-text">Statistics</span>}
    <span class="details-date">{{lastRefreshDate && lastRefreshDate !=''? 'Last Refreshed Date- '+
      lastRefreshDate:''}}</span>
  </div>
  <div class="dashboard-header">
    @if(!myStatsPage){
    <div class="d-flex justify-content-between align-items-stretch">
      <span class="place-heading">{{ country }} - Country status</span>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="bredcrumb">
          <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index; let last = last">
            <span (click)="onBreadcrumbClick(i)" [ngClass]="
                    !last ? 'brancd-prime me-2 cursor-pointer' : 'text-disable me-2'
                  ">{{ breadcrumb }}</span>
            <img *ngIf="!last" src="../../assets/images/chevron.svg" class="me-2" />
          </ng-container>
        </div>
      </div>
    </div>}
    <!-- <app-dp-tab-menu></app-dp-tab-menu> -->
    <app-dp-tab-menu-v3></app-dp-tab-menu-v3>

    <router-outlet></router-outlet>
  </div>
</div>
<!-- <div style="padding: 40px;"> -->
<!-- </div> -->